module.exports = __webpack_public_path__ + "static/media/img-adminqc.bd0072a1.png";